import { Map } from 'immutable';
import sortBy from 'lodash/sortBy';
export function customWalk(
  {
    flatData,
    getKey = node => node.id,
    getParentKey = node => node.parentId,
    rootKey = '0',
    sortableTree,
  },
) {
  if (!flatData) {
    return [];
  }

  let level = 0;
  const flatSortedData = [];

  const childrenToParents = {};
  flatData.forEach(child => {
    const parentKey = getParentKey(child);

    if (parentKey in childrenToParents) {
      const parentToChildrenCopy = [...childrenToParents[parentKey]];
      parentToChildrenCopy.push(child);

      childrenToParents[parentKey] = sortBy(parentToChildrenCopy, childElement =>
        parseInt(childElement.order, 10)
      );
    } else {
      childrenToParents[parentKey] = [child];
    }
  });

  if (!(rootKey in childrenToParents)) {
    return [];
  }


  const trav = (parent, level) => {
    const parentKey = getKey(parent);
    flatSortedData.push(Map({
      title: parent.name,
      level,
      type: 'Work Breakdown Structure',
      id: parent.id,
      parent: parent.parent_id,
      children: childrenToParents[parentKey] ? childrenToParents[parentKey].map(child => child.id) : [],
    }));
    
    if (parentKey in childrenToParents) {
      level = level + 1;
      return {
        ...parent,
        title: parent.name,
        expanded: true,
        children: childrenToParents[parentKey].map(child => trav(child, level)),
      };
    }
    
    level = level - 1;
    
    return {
      ...parent,
      expanded: true,
      title: parent.name,
    };
  };

  const wbsHierarchy = childrenToParents[rootKey].map(child => trav(child, level));

  if (sortableTree) {
    return wbsHierarchy;
  } else {
    return flatSortedData;
  }
}



// WEBPACK FOOTER //
// ./src/components/WbsLayout/helpers.js